import * as React from 'react';

import { FriendsReferralApiService } from '@sitegen/common/classes/friends-referral-api';
import { UbisoftAPIService } from 'modules/ubisoft-api';

import Spinner from 'components/spinner/spinner.component';

import { IGetBetaInfoContainerProps } from './get-friends-referral-info.types';

export class GetFriendsReferralInfo extends React.Component<IGetBetaInfoContainerProps> {
    public componentDidMount(): Promise<void> {
        FriendsReferralApiService.configureSession({
            ticket: this.props.ticket,
            userId: this.props.userId,
        });

        UbisoftAPIService.configure({
            appId: this.props.appId,
            env: this.props.env,
            session: {
                ticket: this.props.ticket,
                sessionId: this.props.sessionId
            }
        });

        return this.props.getFriendsReferralInfo();
    }

    public render(): JSX.Element {
        return <Spinner />;
    }
}
